import http from "../http-common";

const addLitter = (mouseId,data) => {
    return http.post(`/mouse/${mouseId}/litter`,data)
}

const addPup = (litterId) => {
    return http.put(`/mouse/litter/${litterId}/add`)
}

const addCfPup = (litterId) => {
    return http.put(`/mouse/litter/${litterId}/cfAdd`)
}

const createMouse = (data) => {
    console.log("Sending post request to /mouse/create with data: ", data);
    return http.post(`/mouse/create/`, data);
}

const deleteMouse = (data) => {
    console.log("Sending post request to /mouse/delete with data: ", data);
    return http.delete(`/mouse/${data}/`);
}

const getInactiveMouse = (data) => {
    return http.get(`/mouse/inactive/`);
}

const restoreMice = (data) => {
    console.log(data);
    console.log(typeof data);
    return http.post(`/mouse/restore/`, { mouseIds: data });
}

const dropPup = (litterId,data) => {
    return http.put(`/mouse/litter/${litterId}/drop`, data)
}

const getLitter = mouseId => {
    return http.get(`/mouse/${mouseId}/litter`);
}

const getUnfinishedLitters = (litterId) => {
    return http.get(`/mouse/litter/${litterId}/unfinished`)
}

const getLitterAndCages = litterId => {
    return http.get(`/mouse/litter/${litterId}`);
}

const getLitterCages = litterId => {
    return http.get(`/mouse/litter/${litterId}/cages`);
}

const getNextLitter = () => {
    return http.get('mouse/litter/next')
}

const getNextMouse = () => {
    return http.get('/mouse/next')
}

const getMouse = (mouseId) => {
    return http.get(`/mouse/${mouseId}`)
}

const strainPairings = (strain, gender) => {
    return http.get(`/mouse/pairing/${strain}/${gender}`)
}

const updateLitterWean = (litterId, data) => {
    return http.put(`/mouse/litter/${litterId}/wean`, data)
}

const updateLitterNote = (litterId, data) => {
    return http.put(`/mouse/litter/${litterId}/note`, data)
}

const updateLitterPupDeath = (litterId, data) => {
    return http.put(`/mouse/litter/${litterId}/pupDeath`, data)
}

const updateLitterCrossFoster = (litterId, data) => {
    return http.put(`/mouse/litter/${litterId}/crossFoster`, data)
}

const updateMouseNote = (mouseId, data) => {
    return http.put(`mouse/${mouseId}/note`, data)
}

const updateMouseStrain = (mouseId, data) => {
    console.log(data)
    return http.put(`mouse/${mouseId}/strain`, data)
}

const updateMouseSex = (mouseId, data) => {
    return http.put(`mouse/${mouseId}/sex`, data)
}

const finishLitter = (litterId, data) => {
    return http.put(`/mouse/litter/${litterId}/finish`, data)
}

const euthanize = (mouseId, data) => {
    return http.put(`/mouse/${mouseId}/euth`, data);
}

const transfer = (mouseId,data) => {
    return http.put(`/mouse/${mouseId}/transfer`, data);
};

const makeBreeder = (mouseId, toCageId, fromCageId) => {
    return http.put(`/mouse/${mouseId}/breeder/${toCageId}/${fromCageId}`);
}

const retireBreeder = (mouseId, data) => {
    return http.put(`/mouse/${mouseId}/retire`, data);
}

const claimMouse = (mouseId, data) => {
    return http.put(`/mouse/${mouseId}/claim`, data);
}

const genotypeMouse = (mouseId, data) => {
    return http.put(`/mouse/${mouseId}/genotype`, data);
}

// Added by VP 02/2026
const getCensus = (start, end) => {
  // start/end optional; when provided they should be "YYYY-MM-DD"
  return http.get("/mouse/census", {
    params: start && end ? { start, end } : undefined,
  });
};

const MouseService = {
    addLitter,
    addCfPup,
    addPup,
    claimMouse,
    createMouse,
    dropPup,
    deleteMouse,
    restoreMice,
    euthanize,
    finishLitter,
    genotypeMouse,
    getCensus,
    getInactiveMouse,
    getLitter,
    getLitterAndCages,
    getLitterCages,
    getMouse,
    getNextLitter,
    getNextMouse,
    getUnfinishedLitters,
    makeBreeder,
    retireBreeder,
    strainPairings,
    transfer,
    updateLitterCrossFoster,
    updateLitterNote,
    updateLitterWean,
    updateLitterPupDeath,
    updateMouseNote,
    updateMouseStrain,
    updateMouseSex
};

export default MouseService;